import { Validations } from './BaseInputProps'
import { isValidUrl } from '../../libs/Utility/parsers'
import { isArray } from 'lodash'
import { TextInputProps } from './TextInput'
import {
  PASSWORD_PATTERN,
  TEXT_PATTERN,
  XSS_PATTERN,
} from '@libs/Utility/validation'

export const validate = (
  value: any,
  validations: Validations | undefined | 'none'
) => {
  // console.log({ value, validations })
  if (!!value && value !== '' && validations && validations !== 'none') {
    const { minLength, maxLength, pattern, isURL, isUnique } = validations

    if (isUnique && isUnique.value.length > 0) {
      if (isUnique.value.includes(value)) return isUnique.message
    }

    if (pattern) {
      const regex = isArray(pattern) ? [...pattern] : [pattern]
      for (const r of regex) {
        const result = r.value.test(value)
        r.value.lastIndex = 0

        if (r.type === 'avoid' && result) return r.message
        if ((!r.type || r.type === 'match') && !result) return r.message
      }
    }

    if (pattern) {
      const regex = isArray(pattern) ? [...pattern] : [pattern]
      // console.log({ regex })
      for (const r of regex) {
        const result = r.value.test(value)
        r.value.lastIndex = 0

        // console.log({
        //   r,
        //   value,
        //   result,
        //   type: r.type,
        //   // avoid: r.type === 'avoid' && result,
        //   // match: (!r.type || r.type === 'match') && !result,
        // })

        if (r.type === 'avoid' && result) return r.message
        if ((!r.type || r.type === 'match') && !result) return r.message
      }
    }

    if (pattern) {
      const regex = isArray(pattern) ? [...pattern] : [pattern]
      // console.log({ regex })
      for (const r of regex) {
        const result = r.value.test(value)
        r.value.lastIndex = 0

        // console.log({
        //   r,
        //   value,
        //   result,
        //   type: r.type,
        //   // avoid: r.type === 'avoid' && result,
        //   // match: (!r.type || r.type === 'match') && !result,
        // })

        if (r.type === 'avoid' && result) return r.message
        if ((!r.type || r.type === 'match') && !result) return r.message
      }
    }

    if (minLength && value?.length < minLength.value) {
      return minLength.message
    } else if (maxLength && value?.length > maxLength.value) {
      return maxLength.message
    } else if (isURL && !isValidUrl(value)) {
      return 'Invalid URL'
    }
  }
  return ''
}

export const getDefaultValidations = (
  type: string | undefined,
  validations: Validations | undefined | 'none'
) => {
  if (validations === 'none') return {}
  if (!type)
    return {
      ...validations,
      pattern: [
        ...(!!validations?.pattern && isArray(validations?.pattern)
          ? validations?.pattern
          : []),
        {
          value: XSS_PATTERN,
          message: 'Malicious input detected',
          type: 'avoid',
        },
      ],
    }
  if (type === 'password')
    return {
      ...validations,
      minLength: {
        value: 8,
        message: 'Password is too short',
      },
      maxLength: {
        value: 50,
        message: 'Password is too long',
      },
      pattern: [
        ...(!!validations?.pattern && isArray(validations?.pattern)
          ? validations?.pattern
          : []),
        {
          value: XSS_PATTERN,
          message: 'Malicious input detected',
          type: 'avoid',
        },
        {
          value: PASSWORD_PATTERN,
          message:
            'Password must be at least 8 characters and contain an uppercase letter, a lowercase letter, 1 number and 1 special character.',
          type: 'match',
        },
      ],
    }
  if (type === 'text')
    return {
      ...validations,
      pattern: [
        ...(!!validations?.pattern && isArray(validations?.pattern)
          ? validations?.pattern
          : []),
        {
          value: TEXT_PATTERN,
          message: 'Text can only contain A-Z, 0-9, and select special chars',
          type: 'match',
        },
        {
          value: XSS_PATTERN,
          message: 'Malicious input detected',
          type: 'avoid',
        },
      ],
    }

  return {
    ...validations,
    pattern: [
      ...(!!validations?.pattern && isArray(validations?.pattern)
        ? validations?.pattern
        : []),
      {
        value: XSS_PATTERN,
        message: 'Malicious input detected',
        type: 'avoid',
      },
    ],
  }
}

// Helper function to validate URL format
/* function isValidURL(string: string): boolean { */
/*   try { */
/*     if (!string.match(/^[a-zA-Z]+:\/\//)) { */
/*       string = 'http://' + string */
/*     } */
/*     new URL(string) */
/*     const regex = */
/*       /^(https?:\/\/)?(([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$)/ */
/*     return regex.test(string) */
/*   } catch (_) { */
/*     return false */
/*   } */
/* } */
